module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am90-9027413c963031cac34a480ce1c7a438.jpg";